import { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchStatesRequest, resetStatesFailure } from '../../actions/fetchStatesActions';
import {
  subdivisionsSelector,
  fetchStatesLoadingSelector,
  fetchStatesErrorSelector,
  residenceCountrySelector,
  residenceStateSelector,
} from '../../reducers/selectors';

const useStates = () => {
  const [reload, setReload] = useState(0);
  const dispatch = useDispatch();
  const residenceCountry = useSelector(residenceCountrySelector);
  const allStates = useSelector(subdivisionsSelector);
  const isLoading = useSelector(fetchStatesLoadingSelector);
  const error = useSelector(fetchStatesErrorSelector);
  const selected = useSelector(residenceStateSelector);

  useLayoutEffect(() => {
    if (!error && !isLoading && residenceCountry && !allStates[residenceCountry.value]) {
      dispatch(fetchStatesRequest(residenceCountry.value));
    }
  }, [dispatch, allStates, error, isLoading, residenceCountry]);

  const reset = () => {
    dispatch(resetStatesFailure());
    setReload(reload + 1);
  };

  return {
    data: residenceCountry ? allStates[residenceCountry.value] || [] : [],
    isLoading,
    error,
    reload: () => reset(),
    retries: reload,
    selected,
  };
};

export default useStates;
